const SEED_EVENTS = [
  {
    id: 1,
    tDate: '2026-08-25',
    title: 'Annual Academic Orientation & Foundation Convocation',
    particulars: 'Comprehensive orientation programme for all newly enrolled CA Foundation and CS Executive students. Keynote address by board members and guest alumni.',
    instituteId: '1',
    instituteName: 'Tez Educational Trust',
    instituteType: 1,
    branchId: '1',
    branchName: 'Dadar',
    branchType: 1,
    courseId: '1',
    courseName: 'CA Foundation',
    courseType: 1,
    batchId: '1',
    batchName: 'Batch-A (Morning)',
    batchType: 1,
    createdAt: '2026-08-19T09:00:00Z',
  },
  {
    id: 2,
    tDate: '2026-08-28',
    title: 'Inter-College Commerce & Law Debate Championship',
    particulars: 'Annual debate symposium on contemporary corporate governance and tax policy reforms with participation from leading colleges.',
    instituteId: '2',
    instituteName: 'Tolani College Of Commerce',
    instituteType: 1,
    branchId: '2',
    branchName: 'Thane',
    branchType: 1,
    courseId: '2',
    courseName: 'CS Executive',
    courseType: 1,
    batchId: '0',
    batchName: 'All Batches',
    batchType: 2,
    createdAt: '2026-08-18T10:30:00Z',
  },
  {
    id: 3,
    tDate: '2026-09-02',
    title: 'Science Olympiad & JEE Advanced Problem Solving Bootcamp',
    particulars: 'Intensive weekend boot camp covering advanced mechanics, electrodynamics, and organic reaction mechanisms with faculty mentoring.',
    instituteId: '3',
    instituteName: 'Tez Educational School',
    instituteType: 1,
    branchId: '3',
    branchName: 'Andheri',
    branchType: 1,
    courseId: '3',
    courseName: 'JEE Advanced',
    courseType: 1,
    batchId: '3',
    batchName: 'Super-30 (Intensive)',
    batchType: 1,
    createdAt: '2026-08-17T14:15:00Z',
  },
  {
    id: 4,
    tDate: '2026-09-10',
    title: 'Medical Aspirants Guidance & NEET Strategy Seminar',
    particulars: 'Expert panel discussion on botanical diagrams, genetics shortcuts, and high-yield question solving techniques for NEET aspirants.',
    instituteId: '1',
    instituteName: 'Tez Educational Trust',
    instituteType: 1,
    branchId: '0',
    branchName: 'All Branches',
    branchType: 2,
    courseId: '4',
    courseName: 'NEET UG',
    courseType: 1,
    batchId: '0',
    batchName: 'All Batches',
    batchType: 2,
    createdAt: '2026-08-16T11:00:00Z',
  },
]

function getStoredEvents() {
  try {
    const raw = localStorage.getItem('cloud_events_records')
    if (!raw) {
      localStorage.setItem('cloud_events_records', JSON.stringify(SEED_EVENTS))
      return SEED_EVENTS
    }
    return JSON.parse(raw)
  } catch {
    return SEED_EVENTS
  }
}

function saveStoredEvents(list) {
  try {
    localStorage.setItem('cloud_events_records', JSON.stringify(list))
    window.dispatchEvent(new Event('cloud-events-updated'))
  } catch (err) {
    console.error('Failed to save events to localStorage', err)
  }
}

export async function fetchEventsList(filters = {}, sortBy = 'tDate', sortOrder = 'desc') {
  await new Promise((resolve) => setTimeout(resolve, 80))
  let list = getStoredEvents()

  // Filter: Institute
  if (filters.company && filters.company !== 'All') {
    list = list.filter((e) => e.instituteName === filters.company || e.instituteType === 2)
  }
  // Filter: Branch
  if (filters.branch && filters.branch !== 'All') {
    list = list.filter((e) => e.branchName === filters.branch || e.branchType === 2)
  }
  // Filter: Course
  if (filters.course && filters.course !== 'All') {
    list = list.filter((e) => e.courseName === filters.course || e.courseType === 2)
  }
  // Filter: Batch
  if (filters.batch && filters.batch !== 'All') {
    list = list.filter((e) => e.batchName === filters.batch || e.batchType === 2)
  }
  // Filter: Date Range
  if (filters.fromDate) {
    list = list.filter((e) => e.tDate >= filters.fromDate)
  }
  if (filters.tillDate) {
    list = list.filter((e) => e.tDate <= filters.tillDate)
  }

  // Search Filter
  if (filters.searchText) {
    const q = filters.searchText.toLowerCase().trim()
    list = list.filter(
      (e) =>
        (e.title || '').toLowerCase().includes(q) ||
        (e.particulars || '').toLowerCase().includes(q) ||
        (e.instituteName || '').toLowerCase().includes(q) ||
        (e.branchName || '').toLowerCase().includes(q) ||
        (e.courseName || '').toLowerCase().includes(q) ||
        (e.batchName || '').toLowerCase().includes(q)
    )
  }

  // Sorting
  list.sort((a, b) => {
    let valA = a[sortBy] ?? ''
    let valB = b[sortBy] ?? ''
    if (typeof valA === 'string') {
      return sortOrder === 'asc' ? valA.localeCompare(valB) : valB.localeCompare(valA)
    }
    return sortOrder === 'asc' ? valA - valB : valB - valA
  })

  return {
    records: list,
    totalRecords: list.length,
  }
}

export async function getEventById(id) {
  await new Promise((resolve) => setTimeout(resolve, 50))
  const list = getStoredEvents()
  const found = list.find((e) => e.id === parseInt(id, 10))
  if (!found) throw new Error(`Event not found with ID ${id}`)
  return found
}

export async function createEvent(payload) {
  await new Promise((resolve) => setTimeout(resolve, 120))
  const list = getStoredEvents()

  const newRecord = {
    id: Date.now() + Math.floor(Math.random() * 1000),
    tDate: payload.tDate || new Date().toISOString().split('T')[0],
    title: payload.title || '',
    particulars: payload.particulars || '',
    instituteType: payload.instituteType || 1,
    instituteId: payload.instituteId || '',
    instituteName: payload.instituteType === 2 ? 'All Institutes' : payload.instituteName || 'Tez Educational Trust',
    branchType: payload.branchType || 1,
    branchId: payload.branchId || '',
    branchName: payload.branchType === 2 ? 'All Branches' : payload.branchName || 'Dadar',
    courseType: payload.courseType || 1,
    courseId: payload.courseId || '',
    courseName: payload.courseType === 2 ? 'All Courses' : payload.courseName || 'CA Foundation',
    batchType: payload.batchType || 1,
    batchId: payload.batchId || '',
    batchName: payload.batchType === 2 ? 'All Batches' : payload.batchName || 'Batch-A (Morning)',
    createdAt: new Date().toISOString(),
  }

  const updatedList = [newRecord, ...list]
  saveStoredEvents(updatedList)
  return newRecord
}

export async function updateEvent(id, payload) {
  await new Promise((resolve) => setTimeout(resolve, 100))
  const list = getStoredEvents()
  const targetId = parseInt(id, 10)

  const updatedList = list.map((item) => {
    if (item.id === targetId) {
      return {
        ...item,
        ...payload,
        instituteName: payload.instituteType === 2 ? 'All Institutes' : payload.instituteName || item.instituteName,
        branchName: payload.branchType === 2 ? 'All Branches' : payload.branchName || item.branchName,
        courseName: payload.courseType === 2 ? 'All Courses' : payload.courseName || item.courseName,
        batchName: payload.batchType === 2 ? 'All Batches' : payload.batchName || item.batchName,
        updatedAt: new Date().toISOString(),
      }
    }
    return item
  })

  saveStoredEvents(updatedList)
  return updatedList.find((e) => e.id === targetId)
}

export async function deleteEvent(id) {
  await new Promise((resolve) => setTimeout(resolve, 80))
  const list = getStoredEvents()
  const targetId = parseInt(id, 10)
  const filtered = list.filter((e) => e.id !== targetId)
  saveStoredEvents(filtered)
  return { success: true }
}
